import createDataContext from './createDataContext';
import * as actions from './actions/tankLevelActions';
import { reducer, initialState } from './reducers/tankLevelReducer';

export const { Context: TankLevelContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
